<script setup lang="ts">
export interface EsgMeasure {
  initial: string
  label: string
  score: number | null | undefined
}

export interface Props {
  measure: EsgMeasure
}
const props = defineProps<Props>()

const badgeClass = computed(() => 'esg-category-' + props.measure.initial)
</script>
<template lang="pug">
div(
  v-if="props.measure"
  class="esg-category inline-flex flex-row items-center font-semibold w-full flex-1 antialiased"
  :class="badgeClass"
  :aria-label="`OpenESG Sustainability ID for ${props.measure.initial}: ${props.measure.label}`"
)
  div(
    class="flex-1 basis-2/5 initial py-4 text-center text-base uppercase text-gray-100 rounded-tr-[0.5625rem]"
  ) {{ props.measure.initial }}
  div(class="flex-1 basis-3/5 py-4 text-center text-sm font-bold") {{ props.measure.score?.toFixed(0) || 0 }}
</template>
<style scoped lang="postcss">
.esg-category {
  &-e {
    @apply bg-category-e-light text-category-e-dark;
    .initial {
      @apply bg-category-e;
    }
  }
  &-s {
    @apply bg-category-s-light text-category-s;
    .initial {
      @apply bg-category-s;
    }
  }
  &-g {
    @apply bg-category-g-light text-category-g;
    .initial {
      @apply bg-category-g;
    }
  }
}
</style>
